<div class="device-controls"
     fxlayout="row">
    <button aria-label="Update Cellular Device Status"
            class="borderless"
            *ngIf="!device.$isInEditMode && device.isScada && device.cellularDevice"
            (click)="updateCellularDeviceStatus($event)">
        <mat-icon matTooltip="Update Cellular Device Status"
                  matTooltipPosition="below">
            wifi
        </mat-icon>
    </button>
    <button class="borderless"
            *ngIf="!device.$isInEditMode"
            (click)="toggleReaderView($event)">
        <mat-icon matTooltip="Toggle Reader Statuses"
                  matTooltipPosition="below">
            event_note
        </mat-icon>
    </button>
    <button aria-label="View Module"
            class="borderless"
            (click)="buttonHandler($event, viewMenuItem)">
        <mat-icon [matTooltip]="viewMenuItem?.label"
                  matTooltipPosition="below">
            {{ viewMenuItem?.icon }}
        </mat-icon>
    </button>
    <button class="borderless"
            *ngIf="!device.$isInEditMode"
            [matMenuTriggerFor]="menu">
        <mat-icon [matTooltip]="'Open Menu'"
                  matTooltipPosition="below">
            menu
        </mat-icon>
    </button>
    <mat-menu class="borderless"
              #menu="matMenu">
        <ng-container *ngFor="let item of detailViewService.menuItems | keyvalue: originalOrder">
            <button *ngIf="item.value !== viewMenuItem && !item.value.isHamburgerItem"
                    mat-menu-item
                    [hidden]="!isVisible(item.value)"
                    (click)="buttonHandler($event, item.value)">
                <mat-icon>{{ item.value.icon }}</mat-icon>
                <span class="borderless">{{ item.value.label }}</span>
            </button>
        </ng-container>
    </mat-menu>
    <ng-container *ngFor="let item of detailViewService.menuItems | keyvalue: originalOrder">
        <button class="borderless"
                *ngIf="device.$isInEditMode && showEditButton(item.value)"
                (click)="buttonHandler($event, item.value)">
            <mat-icon [matTooltip]="item.value.label"
                      matTooltipPosition="below">
                {{ item.value.icon }}
            </mat-icon>
        </button>
    </ng-container>
</div>
